import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var App;

@Injectable({
  providedIn: 'root'
})
export class MembershipPaymentService {
 
  constructor(private http: HttpClient) { }

  saveDetailsApi(data) {
    return this.http.post<any>(App.base_url + 'payment/make', data);
  }

  getBroucher(data) {
    window.open(App.base_url + 'downloadBrochure?id='+data.id)
    // return this.http.get<any>(App.base_url + 'downloadBrochure?id='+data.id);
  }

  downloadTnCFile(data) {
    window.open(App.base_url + 'downloadTnCFile?id='+data.id)
    // return this.http.get<any>(App.base_url + 'downloadBrochure?id='+data.id);
  }


  getAllFamilyMembers(data) {
    return this.http.post<any>(App.base_url + 'getFamilyMembers', (data !== null) ? data :null);    
  }
  addMemberApi(data) {
    return this.http.post<any>(App.base_url + 'addMember', data);
  }

  getStatesApi(data){
    return this.http.post<any>(App.base_url + 'getStates', data);
  }

  getUserPreviousPlanAmount(data){
    return this.http.post<any>(App.base_url + 'getUserPreviousPlanAmount', data);
  }

  getCouponsApi(data){
    return this.http.post<any>(App.base_url + 'checkCoupons', data);
  }

  deleteCoupon(data){
    return this.http.post<any>(App.base_url + 'deleteCoupon', data);
  }

  getSubscriptionsApi(data){
    return this.http.post<any>(App.base_url + 'getUserSubscription', data);
  }

  getUserInActiveSubscriptions(data){
    return this.http.post<any>(App.base_url + 'getUserInActiveSubscriptions', data);
  }

  cancelSubscriptionsApi(data){
    return this.http.post<any>(App.base_url + 'cancelSubscription', data);
  }

  getOrganisationsApi(){
    return this.http.post<any>(App.base_url + 'getCouponsOrganization', null);
  }

  getdeductions(data){
    return this.http.post<any>(App.base_url + 'getdeductions', data);
  }

  getQuotePrices(data){
    return this.http.post<any>(App.base_url + 'getQuote', data);
  }

  planPurchase(data){
    return this.http.post<any>(App.base_url + 'purchasePlan', data);
  }

  getUserPlanStartDate(data){
    return this.http.post<any>(App.base_url + 'getUserPlanStartDate', data);
  }

  logoutApi(data){
    return this.http.post<any>(App.base_url + 'do-logout', data);
  }

  updateUserTimeZone(data){
    return this.http.post<any>(App.base_url + 'updateUserTimeZone', data);
  }
  
  signUpApi(data){
    return this.http.post<any>(App.base_url + 'users/save', data);
  }

  checkUserExistingPlans(data){
    return this.http.post<any>(App.base_url + 'checkUserExistingPlans', data);
  }

  signInApi(data){
    return this.http.post<any>(App.base_url + 'getLogin', data);
  }

  forgotPassword(data) {
    return this.http.post<any>(App.base_url + 'forgotPassword', data);
  }

  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      Authorization: 'my-auth-token',
       // id: App.user_details.id
    })
  };

  goToPage(url){
    //console.log(url);
    return this.http.post(url, this.httpOptions);
  }

  
}